/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { batchActions } from "redux-batched-actions";
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { getClientEmbedsData, archiveEmbed, unarchiveEmbed, editEmbed, viewAnalytics, viewEmails, deleteEmbed, getEmbedNames } from 'state/actions/embedsState/embeds_status';
import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { displayModal } from '@insticator/insticator-ui'; // iui-utils
// component
import LibraryPage from 'pages/dashboard/embeds/library/library';



/* ========== ~~~~~~~~~~ EMBED LIBRARY : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus, accountData }) => ({
    accountUUID: sessionStatus.accountUUID,
    userFirstName: sessionStatus.userFirstName,
    isDataReceived: embedsState.embedsStatus.isDataReceived,
    clientEmbeds: embedsState.embedsStatus.clientEmbeds,
    fetchingEmbeds: embedsState.embedsStatus.fetchingEmbeds,
    currentPage: embedsState.embedsStatus.currentPage,
    totalEmbeds: embedsState.embedsStatus.totalEmbeds,
    totalRows: embedsState.embedsStatus.totalRows,
    totalPages: embedsState.embedsStatus.totalPages,
    archiving: embedsState.embedsStatus.archiving,
    toggledArchive: embedsState.embedsStatus.toggledArchive,
    fetchingEmbedNames: embedsState.embedsStatus.fetchingEmbedNames,
    embedNames: embedsState.embedsStatus.embedNames,
    clientSites: accountData.sites,
    mocked: sessionStatus.mocked,
    mockupGenerator: sessionStatus.mockupGenerator,
    siteUUID: sessionStatus.siteUUID,
    editPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('manageEmbeds'),
    labels: embedsState.embedsStatus.labels,

});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(location));
    	dispatch(changePage(location))
    },
    moveToEmbedCreationWithStateReset: () => {
        dispatch(batchActions([
            resetEmbedState(),
            resetContentState({ setInitialContentId: true }),
        ]));
        dispatch(updatePageDetails('dashboard/embeds/management/getstarted'));
        dispatch(updateStepDetails('getstarted'));
        dispatch(changePage('dashboard/embeds/management/getstarted'))
    },
    editEmbed: embedUUID => dispatch(editEmbed(embedUUID)),
    viewAnalytics: (embedUUID, accountUUID, embedName) => dispatch(viewAnalytics(embedUUID, accountUUID, embedName)),
    viewEmails: (embedUUID, embedName) => dispatch(viewEmails(embedUUID, embedName)),
    deleteEmbed: (embedUUID,accountUUID, callback) => dispatch(deleteEmbed(embedUUID, accountUUID, callback)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    resetEmbedAndContentState: () => dispatch(batchActions([
        resetEmbedState(),
        resetContentState({ setInitialContentId: false }),
    ])),
    getClientEmbedsData: (accountUUID, filters) => dispatch(getClientEmbedsData(accountUUID, filters)),
    archiveEmbed: (embedUUID, embedName, callBack) => dispatch(archiveEmbed(embedUUID, embedName, callBack)),
    unarchiveEmbed: (embedUUID, embedName, callBack) => dispatch(unarchiveEmbed(embedUUID, embedName, callBack)),
    getEmbedNames: (accountUUID, callBack) => dispatch(getEmbedNames(accountUUID, callBack))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(LibraryPage);
